import {
    addCurrentTarget,
    addSalespersonTarget, deleteCurrentTarget,
    deleteSalespersonTarget, getListCurrentTarget,
    getListSalespersonTarget, getSingleCurrentTarget,
    getSingleSalespersonTarget, updateCurrentTarget,
    updateSalespersonTarget,
    // getSingleSalespersonTarget
}
    from "@/services/modules/target/targetService";
import {showProcessErrorMessage, showProcessPromptMessage, showProcessSuccessMessage} from "@/state/alertHelpers";
// import {
//     showProcessErrorMessage,
//     showProcessPromptMessage,
//     showProcessSuccessMessage,
// } from "../alertHelpers.js";

export const state = {
    targetList: [],
    targetListHeaders: [],
    targetListLoading: [],
    noTargetMessage: [],
};
export const mutations = {
    setTargetList(state,data) {
        state.targetList = data;
    },
    setTargetListHeaders(state, data) {
        state.targetListHeaders = data;
    },
    setTargetListLoading(state,data) {
        state.targetListLoading = data;
    },
    setNoTargetMessage(state,data) {
        state.noTargetMessage = data;
    },
}
export const actions = {
    async fetchSalespersonTargetList (context,{params,body}) {
        context.commit("setTargetListHeaders", [
            {
                key:"salesPersonCode",
                label:"Plasiyer Kodu",
                sortable:false,
            },
            {
                key:"salesPersonName",
                label:"Plasiyer Adı",
                sortable: true,
            },
            {
                key:"targetLimit",
                label:"Hedef",
                sortable:true,
            },
            {
                key:"startDate",
                label:"Başlangıç Tarihi",
                sortable: false,
            },
            {
                key:"finishDate",
                label:"Bitiş Tarihi",
                sortable: false,
            },
            {
                key:"process",
                label: "İşlem",
                sortable: false,
                class: "text-center align-middle",
            }
        ]);
        context.commit("setTargetListLoading",true);
        let result = await getListSalespersonTarget(params, body);
        if (result && result.data && result.data.data) {
            result.data.data.forEach(item => {
                if (item.startDate && item.finishDate) {
                    item.startDate = item.startDate.split('T')[0];
                    item.finishDate = item.finishDate.split('T')[0];
                }
            });
        }
        context.commit("setTargetListLoading",false);
        if (result.data.success)
            context.commit("setTargetList", result.data.data);
        else {
            context.commit("setNoTargetMessage",result.data.message);
            context.commit("setTargetList",[]);
        }
        return result;
    },
    async salesPersonTargetGetSingle(context,{params,body}) {
        context;
        let result = await getSingleSalespersonTarget(params,body);
        if (result.data.success) {
            showProcessSuccessMessage({
                title: "İşlem Başarılı",
                text: result.data.messages,
            }).then(() => {
                context.dispatch("fetchSalespersonTargetList", {
                    params: {},
                    body: {},
                })
            })
        } else
            showProcessErrorMessage({
                title: "İşlem Başarısız",
                text: result.data.message,
            });
        return result;
    },
    async salespersonTargetAdd(context,{params,body}) {
        context;
        let result = await addSalespersonTarget(params,body);
        if (result.data.success) {
            showProcessSuccessMessage({
                title: "İşlem Başarılı",
                text: result.data.messages,
            }).then(() => {
                context.dispatch("fetchSalespersonTargetList", {
                    params: {},
                    body: {},
                })
            })
        } else
            showProcessErrorMessage({
                title: "İşlem Başarısız",
                text: result.data.message,
            });
        return result;
    },
    async salespersonTargetUpdate(context,{params,body}) {
        context;
        let result = await updateSalespersonTarget(params,body);
        if (result.data.success) {
            showProcessSuccessMessage({
                title: "İşlem Başarılı",
                text: result.data.messages,
            }).then(() => {
                context.dispatch("fetchSalespersonTargetList", {
                    params: {},
                    body: {},
                })
            })
        } else
            showProcessErrorMessage({
                title: "İşlem Başarısız",
                text: result.data.message,
            });
        return result;
    },
    async salespersonTargetDelete(context, {params,body,urlSegments} ){
        context;
        showProcessPromptMessage({
            title:"Plasiyer Hedefi Silinecek",
            text:"Yapılan işlem geri alınamayacaktır. İşleme devam etmek istiyor musunuz?",
        }).then(async function(confirm){
            if (confirm.isConfirmed){
                let result = await deleteSalespersonTarget(params,body,urlSegments);
                if (result.data.success){
                    showProcessSuccessMessage({
                        title:"İşlem Başarılı",
                        text:result.data.message,
                    }).then(
                        context.dispatch('fetchSalespersonTargetList', {
                            params: {},
                            body: {},
                        })
                    );
                } else
                    showProcessErrorMessage(({
                        title: "İşlem Başarısız",
                        text: result.data.message,
                    }));
                return result;
            }
        })

    },

    async fetchCurrentTargetList (context,{params,body}) {
        context.commit("setTargetListHeaders", [
            {
                key:"currentCode",
                label:"Cari Kodu",
                sortable:false,
            },
            {
                key:"currentName",
                label:"Cari Adı",
                sortable: true,
            },
            {
                key:"targetLimit",
                label:"Hedef",
                sortable:true,
            },
            {
                key:"startDate",
                label:"Başlangıç Tarihi",
                sortable: false,
            },
            {
                key:"finishDate",
                label:"Bitiş Tarihi",
                sortable: false,
            },
            {
                key:"process",
                label: "İşlem",
                sortable: false,
                class: "text-center align-middle",
            }
        ]);
        context.commit("setTargetListLoading",true);
        let result = await getListCurrentTarget(params, body);
        if (result && result.data && result.data.data) {
            result.data.data.forEach(item => {
                if (item.startDate && item.finishDate) {
                    item.startDate = item.startDate.split('T')[0];
                    item.finishDate = item.finishDate.split('T')[0];
                }
            });
        }
        context.commit("setTargetListLoading",false);
        if (result.data.success)
            context.commit("setTargetList", result.data.data);
        else {
            context.commit("setNoTargetMessage",result.data.message);
            context.commit("setTargetList",[]);
        }
        return result;
    },
    async currentGetSingle(context,{params,body}) {
        context;
        let result = await getSingleCurrentTarget(params,body);
        if (result.data.success) {
            showProcessSuccessMessage({
                title: "İşlem Başarılı",
                text: result.data.messages,
            }).then(() => {
                context.dispatch("fetchCurrentTargetList", {
                    params: {},
                    body: {},
                })
            })
        } else
            showProcessErrorMessage({
                title: "İşlem Başarısız",
                text: result.data.message,
            });
        return result;
    },
    async currentTargetAdd(context,{params,body}) {
        context;
        let result = await addCurrentTarget(params,body);
        if (result.data.success) {
            showProcessSuccessMessage({
                title: "İşlem Başarılı",
                text: result.data.messages,
            }).then(() => {
                context.dispatch("fetchCurrentTargetList", {
                    params: {},
                    body: {},
                })
            })
        } else
            showProcessErrorMessage({
                title: "İşlem Başarısız",
                text: result.data.message,
            });
        return result;
    },
    async currentTargetUpdate(context,{params,body}) {
        context;
        let result = await updateCurrentTarget(params,body);
        if (result.data.success) {
            showProcessSuccessMessage({
                title: "İşlem Başarılı",
                text: result.data.messages,
            }).then(() => {
                context.dispatch("fetchCurrentTargetList", {
                    params: {},
                    body: {},
                })
            })
        } else
            showProcessErrorMessage({
                title: "İşlem Başarısız",
                text: result.data.message,
            });
        return result;
    },
    async currentTargetDelete(context, {params,body,urlSegments} ){
        context;
        showProcessPromptMessage({
            title:"Cari Hedefi Silinecek",
            text:"Yapılan işlem geri alınamayacaktır. İşleme devam etmek istiyor musunuz?",
        }).then(async function(confirm){
            if (confirm.isConfirmed){
                let result = await deleteCurrentTarget(params,body,urlSegments);
                if (result.data.success){
                    showProcessSuccessMessage({
                        title:"İşlem Başarılı",
                        text:result.data.message,
                    }).then(
                        context.dispatch('fetchCurrentTargetList', {
                            params: {
                            },
                            body: {
                            },
                        })
                    );
                } else
                    showProcessErrorMessage(({
                        title: "İşlem Başarısız",
                        text: result.data.message,
                    }));
                return result;
            }
        })

    }
}